import {
    PROFILE_REQUEST,
    PROFILE_SUCCESS,
    PROFILE_FAILURE,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
};

export const profileReducer = (state = initialState, action) => {
    const {type, data} = action;
    switch (type) {
        case PROFILE_SUCCESS: {
            return {
                ...state,
                isFetched: true,
                isFetching: false,
                data,
            };
        }

        // REQUEST and FAILURE keep whatever profile is already loaded —
        // front/docs/SPA_ARCHITECTURE_AUDIT.md finding RD1. Dropping it makes
        // the account page blank itself on every revisit while the refresh
        // is in flight, and blank again if that refresh fails.
        case PROFILE_REQUEST: {
            return {
                ...state,
                isFetching: true,
            };
        }

        case PROFILE_FAILURE: {
            return {
                ...state,
                isFetching: false,
            };
        }

        default: {
            return state;
        }
    }
};
